import moment from 'moment'
import axios from "axios"
// import path from "path"

const runAxios = async(pOption) => {
    return new Promise((resolve, reject) => {
        axios(pOption)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const uuid = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

const now = () => {
    return moment().format("YYYY-MM-DD HH:mm:ss");
}
const today = () => {
    return moment().format("YYYY-MM-DD");
}
const cdate = (timestamp) => {
    return moment(timestamp).format("YYYY-MM-DD");
}

const nowAdd = (span, unit = "m", format = "YYYY-MM-DD HH:mm:ss") => {
    // return moment().add(span, unit).format(format);
    return moment().add(span, unit).format(format);
}
const dateAdd = (timestamp, span, unit = "m", format = "YYYY-MM-DD HH:mm:ss") => {
    // return moment().add(span, unit).format(format);
    // console.log("timestamp", timestamp)
    let newDate = moment(timestamp)
    return newDate.add(span, unit).format(format);
}


const str = (value) => {
    try {
        if (value == undefined) return ""
        if (value == null) return ""
        return value.toString().trim()
    } catch (error) {
        return ""
    }
}

const quot = (value, len = 0) => {
    if (len > 0) value = value.substring(0, len)
    return "'" + str(value) + "'"
}

const val = (value) => {
    try {
        let output = Number(str(value))
        if (isNaN(output)) return 0
        return output
    } catch (error) {
        return 0
    }
}

const sum = (jsonArray, key) => {
    if (jsonArray == undefined) { return ""; }
    if (jsonArray.length == 0) { return 0; }
    jsonArray.map(r => r[key] = val(r[key]))
    var sum = jsonArray.map(r => r[key]).reduce((sum, qty) => sum + val(qty));
    sum = Number(sum);
    return sum;
}

const nl2br = (text) => {
    text = text.toString();
    return text.replaceAll("\n", "<br/>");
}

const pre = (data) => {
    return JSON.stringify(data, null, 4)
}

const money = (num) => { //三位一撇
    num = val(num)
    let str = num.toString();
    let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
};

const groupBy = (data, key, ...fields) => {
    try {
        var keys = [];
        var set = new Set();
        var res = data.filter(r => !set.has(r[key]) ? set.add(r[key]) : false);
        res.forEach(r => {
            keys.push(r[key])
        });
        // console.log("fields", fields)
        keys = keys.map(r => {
            let row = {}
            row[key] = r
            fields.forEach(r1 => {
                let array = data.filter(r1 => r1[key] == r)
                row[r1] = sum(array, r1)
            })
            return row
        })
        return keys;
    } catch (error) {
        return data;
    }
}

const groupBy1 = (data, key = [], ...fields) => {
    try {
        let keys = [];
        var set = new Set();
        var res = data.filter(r => !set.has(r[key]) ? set.add(r[key]) : false);
        res.forEach(r => {
            keys.push(r[key])
        });
        console.log("data", data)
        console.log("keys", keys)
        keys = keys.map(r => {
            let row = {}
            row[key] = r
            fields.forEach(r1 => {
                let array = data.filter(r1 => r1[key] == r)
                row[r1] = sum(array, r1)
            })
            return row
        })
        return keys;
    } catch (error) {
        return data;
    }
}

const MonthToDateAll = (pOpMonth) => {
    let monthDate = [];
    let monthStart = moment(pOpMonth, "YYYY-MM-DD").startOf('month').toDate().valueOf();
    let monthEnd = moment(pOpMonth, "YYYY-MM-DD").endOf('month').toDate().valueOf();
    for (let dateV = monthStart; dateV <= monthEnd; dateV = moment(dateV).add(1, 'd').toDate().valueOf()) {
        monthDate.push(moment(dateV).format("YYYY-MM-DD"));
    }
    return monthDate;
}

// export default { now, today, str, quot, val, sum, uuid, runAxios, nl2br, cdate, pre, money, groupBy, groupBy1, MonthToDateAll }
export { now, today, str, quot, val, sum, uuid, runAxios, nl2br, cdate, pre, money, groupBy, groupBy1, MonthToDateAll, nowAdd, dateAdd }